import { OAMResultsDeposit } from "../useFilters";

export function isCancelled(deposit: OAMResultsDeposit) {
  return deposit.listeActionDepo === "IANU"
}